export const COLUMNS = [
  { key: "vehicle", label: "Voertuig", locked: true },
  { key: "registration", label: "1e toelating", on: true },
  { key: "mileage", label: "KM", on: true },
  { key: "country", label: "Land", on: true },
  { key: "seller", label: "Verkoper", on: true },
  { key: "source", label: "Bron", on: false },
  { key: "price", label: "Vraagprijs", on: true },
  { key: "price_drop", label: "Prijs verlaagd", on: true },
  { key: "vat", label: "BTW", on: true },
  { key: "bpm", label: "BPM", on: true },
  { key: "transport", label: "Transport", on: false },
  { key: "import_costs", label: "Import/kosten", on: false },
  { key: "landed", label: "Landed cost", on: true },
  { key: "market_value", label: "Verwacht NL", on: true },
  { key: "contribution", label: "Bijdrage", on: true },
  { key: "roi", label: "ROI", on: true },
  { key: "score", label: "Deal Score", on: true },
  { key: "risk", label: "Risico", on: true },
  { key: "confidence", label: "Betrouwbaarheid", on: false },
  { key: "status", label: "Status", on: true },
];

// Only a UI preference (which columns are visible) is stored locally — never
// authentication data, which lives in an httpOnly cookie.
export const STORAGE_KEY = "ati_opportunity_columns_v2";

export const DEFAULT_COLUMNS = COLUMNS.filter((c) => c.locked || c.on).map((c) => c.key);

export function loadColumns() {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    if (Array.isArray(raw) && raw.length) {
      const valid = raw.filter((key) => COLUMNS.some((c) => c.key === key));
      return ["vehicle", ...valid.filter((k) => k !== "vehicle")];
    }
  } catch (e) {
    console.warn("Kolomvoorkeur onleesbaar, standaardkolommen gebruikt:", e);
  }
  return DEFAULT_COLUMNS;
}

export function saveColumns(keys) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
  } catch (e) {
    console.warn("Kolomvoorkeur kon niet worden opgeslagen:", e);
  }
}
